import React, { createContext, useState, useContext } from "react";
import HomeConten from "../Component/Sections/HomeConten";
import WyContract from "../Component/Sections/WyContract";
import Services from "../Component/Sections/Services";
import Contractme from "../Component/Sections/Contactme";
export const RenderContext = createContext();

const RenderProvider = (props) => {
  const [page, setPage] = useState(null);
  const pages = [
    "Inicio",
    "Nuestros Servicios",
    "¿Por Qué Elegirnos?",
    "¡Contáctanos Hoy!",
  ];
  
  const handlePageconten = () => {
    switch (page) {
      case "m0":
        return <HomeConten />;

      case "m1":
        return <Services />;

      case "m2":
        return <WyContract />;
      
      case "m3":
        return <Contractme />;

      default:
        return <HomeConten />;
    }
  };

  const handleMenu = (e) => {
    e.preventDefault();

    if (page !== null) {
      setPage(null);
      return setPage(e.target.id);
    } else {
      return setPage(e.target.id);
    }
  };

  return (
    <RenderContext.Provider
      value={{
        page,
        pages,
        setPage,
        handlePageconten,
        handleMenu,
      }}
    >
      {props.children}
    </RenderContext.Provider>
  );
};

export default RenderProvider;
